import React from 'react';
import HeroSlider from './HeroSlider';
import AboutUs from './AboutUs';
import Services from './Services';
import Insights from './Insights';
import GlobalCorporation from './GlobalCorporation';
import Blogs from './Blogs';
import BusinessSetup from './BusinessSetup';
import ClientCarousel from './ClientCarousel';
import CountryList from './CountryList';
import StrategicLitigation from './StrategicLitigation';
import Testimonials from './Testimonials';
import Certifications from './Certifications';
import '../globals.css';
import MetaUpdater from '../metadata/MetaUpdater';

const Home: React.FC = () => {
  return (
    <>
      <MetaUpdater page="home" />
      <HeroSlider />
      <AboutUs />
      <Services />
      <Insights />
      <GlobalCorporation />
      <Blogs />
      <BusinessSetup />
      <ClientCarousel />
      <CountryList />
      <StrategicLitigation />
      <Testimonials />
      <Certifications />
    </>
  );
};

export default Home;
